import React from 'react';
import {
  Wifi, Tv, Utensils, Coffee, Refrigerator, Microwave, ChefHat, Wine,
  Wind, Flame, Snowflake, Droplets, Bath, ShowerHead, WashingMachine, Shirt,
  Car, BatteryCharging, ParkingSquare, Bike,
  Waves, TreePine, Sun, Mountain, Tent, Trees, Flower2,
  Dumbbell, Gamepad2, Music, BookOpen,
  Baby, Dog, Accessibility,
  Shield, AlertTriangle, Lock, KeyRound, BellRing, Cctv,
  Briefcase, Monitor, Printer, Smartphone,
  Sparkles, Cigarette, Hotel, Bed,
  Fan, Lightbulb, Hammer, Box, Package,
  Home,
} from 'lucide-react';

// Master list grouped by category. `id` is what's saved to the DB
// (kebab-case, stable). `label` is human-facing.
export const AMENITY_GROUPS = [
  {
    title: 'Essentials',
    items: [
      { id: 'wifi', label: 'WiFi', icon: Wifi },
      { id: 'tv', label: 'TV', icon: Tv },
      { id: 'heating', label: 'Heating', icon: Flame },
      { id: 'ac', label: 'Air conditioning', icon: Wind },
      { id: 'washer', label: 'Washer', icon: WashingMachine },
      { id: 'dryer', label: 'Dryer', icon: Shirt },
      { id: 'iron', label: 'Iron', icon: Shirt },
      { id: 'hair-dryer', label: 'Hair dryer', icon: Wind },
      { id: 'hangers', label: 'Hangers', icon: Shirt },
      { id: 'essentials', label: 'Towels & linens', icon: Bed },
    ],
  },
  {
    title: 'Kitchen & Dining',
    items: [
      { id: 'kitchen', label: 'Kitchen', icon: Utensils },
      { id: 'fridge', label: 'Refrigerator', icon: Refrigerator },
      { id: 'microwave', label: 'Microwave', icon: Microwave },
      { id: 'oven', label: 'Oven', icon: ChefHat },
      { id: 'stove', label: 'Stove', icon: Flame },
      { id: 'dishwasher', label: 'Dishwasher', icon: Droplets },
      { id: 'coffee-maker', label: 'Coffee maker', icon: Coffee },
      { id: 'kettle', label: 'Kettle', icon: Coffee },
      { id: 'dishes', label: 'Dishes & silverware', icon: Utensils },
      { id: 'wine-glasses', label: 'Wine glasses', icon: Wine },
      { id: 'toaster', label: 'Toaster', icon: Box },
    ],
  },
  {
    title: 'Bathroom',
    items: [
      { id: 'shower', label: 'Shower', icon: ShowerHead },
      { id: 'bathtub', label: 'Bathtub', icon: Bath },
      { id: 'hot-water', label: 'Hot water', icon: Droplets },
      { id: 'shampoo', label: 'Shampoo', icon: Sparkles },
      { id: 'body-soap', label: 'Body soap', icon: Sparkles },
      { id: 'toilet-paper', label: 'Toilet paper', icon: Package },
    ],
  },
  {
    title: 'Outdoor',
    items: [
      { id: 'pool', label: 'Pool', icon: Waves },
      { id: 'hot-tub', label: 'Hot tub', icon: Bath },
      { id: 'patio', label: 'Patio', icon: Sun },
      { id: 'balcony', label: 'Balcony', icon: Mountain },
      { id: 'backyard', label: 'Backyard', icon: TreePine },
      { id: 'garden', label: 'Garden', icon: Flower2 },
      { id: 'bbq', label: 'BBQ grill', icon: Flame },
      { id: 'firepit', label: 'Fire pit', icon: Tent },
      { id: 'beach-access', label: 'Beach access', icon: Waves },
      { id: 'lake-access', label: 'Lake access', icon: Droplets },
      { id: 'mountain-view', label: 'Mountain view', icon: Mountain },
      { id: 'city-view', label: 'City view', icon: Hotel },
      { id: 'forest-view', label: 'Forest view', icon: Trees },
    ],
  },
  {
    title: 'Parking & Transport',
    items: [
      { id: 'parking', label: 'Free parking on premises', icon: Car },
      { id: 'street-parking', label: 'Street parking', icon: ParkingSquare },
      { id: 'paid-parking', label: 'Paid parking', icon: ParkingSquare },
      { id: 'ev-charger', label: 'EV charger', icon: BatteryCharging },
      { id: 'bike', label: 'Bikes available', icon: Bike },
    ],
  },
  {
    title: 'Entertainment & Wellness',
    items: [
      { id: 'gym', label: 'Gym', icon: Dumbbell },
      { id: 'sauna', label: 'Sauna', icon: Flame },
      { id: 'fireplace', label: 'Indoor fireplace', icon: Flame },
      { id: 'sound-system', label: 'Sound system', icon: Music },
      { id: 'game-console', label: 'Game console', icon: Gamepad2 },
      { id: 'books', label: 'Books & reading', icon: BookOpen },
      { id: 'smart-tv', label: 'Smart TV', icon: Tv },
    ],
  },
  {
    title: 'Family & Accessibility',
    items: [
      { id: 'crib', label: 'Crib', icon: Baby },
      { id: 'high-chair', label: 'High chair', icon: Baby },
      { id: 'pets-allowed', label: 'Pets allowed', icon: Dog },
      { id: 'step-free-access', label: 'Step-free access', icon: Accessibility },
      { id: 'wide-doorway', label: 'Wide doorway', icon: Accessibility },
    ],
  },
  {
    title: 'Workspace',
    items: [
      { id: 'workspace', label: 'Dedicated workspace', icon: Briefcase },
      { id: 'desk', label: 'Desk', icon: Monitor },
      { id: 'monitor', label: 'External monitor', icon: Monitor },
      { id: 'printer', label: 'Printer', icon: Printer },
      { id: 'fast-wifi', label: 'Fast WiFi (50+ Mbps)', icon: Wifi },
    ],
  },
  {
    title: 'Safety',
    items: [
      { id: 'smoke-alarm', label: 'Smoke alarm', icon: AlertTriangle },
      { id: 'co-alarm', label: 'CO alarm', icon: AlertTriangle },
      { id: 'fire-extinguisher', label: 'Fire extinguisher', icon: Flame },
      { id: 'first-aid', label: 'First aid kit', icon: Shield },
      { id: 'security-cameras', label: 'Exterior security cameras', icon: Cctv },
      { id: 'lockbox', label: 'Lockbox', icon: Lock },
    ],
  },
  {
    title: 'Check-in & Stay',
    items: [
      { id: 'self-check-in', label: 'Self check-in', icon: KeyRound },
      { id: 'smart-lock', label: 'Smart lock', icon: Lock },
      { id: 'building-staff', label: 'Building staff', icon: BellRing },
      { id: 'long-term', label: 'Long-term stays allowed', icon: Hotel },
      { id: 'cleaning-products', label: 'Cleaning products', icon: Sparkles },
      { id: 'no-smoking', label: 'No smoking', icon: Cigarette },
    ],
  },
];

// Quick lookup map { id: label }
export const AMENITY_LABEL_BY_ID = AMENITY_GROUPS.reduce((acc, group) => {
  group.items.forEach((item) => {
    acc[item.id] = item.label;
  });
  return acc;
}, {});

const AmenitiesSelector = ({ selected = [], onChange, testidPrefix = 'amenity' }) => {
  const toggle = (id) => {
    const exists = selected.includes(id);
    const next = exists ? selected.filter((a) => a !== id) : [...selected, id];
    onChange(next);
  };

  return (
    <div className="space-y-6" data-testid={`${testidPrefix}-selector`}>
      <p className="text-xs text-gray-500">
        Selected: <span className="font-medium text-gray-700">{selected.length}</span>
      </p>
      {AMENITY_GROUPS.map((group) => (
        <div key={group.title}>
          <h4 className="text-sm font-semibold text-gray-800 mb-3">{group.title}</h4>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
            {group.items.map((amenity) => {
              const Icon = amenity.icon || Home;
              const isSelected = selected.includes(amenity.id);
              return (
                <button
                  key={amenity.id}
                  type="button"
                  data-testid={`${testidPrefix}-${amenity.id}`}
                  onClick={() => toggle(amenity.id)}
                  aria-pressed={isSelected}
                  className={`p-3 border rounded-lg flex items-center gap-2 text-left transition-all ${
                    isSelected
                      ? 'border-blue-500 bg-blue-50 text-blue-700'
                      : 'border-gray-200 hover:border-gray-400 text-gray-700'
                  }`}
                >
                  <Icon className="w-4 h-4 shrink-0" />
                  <span className="text-sm font-medium truncate">{amenity.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AmenitiesSelector;
